export const INTERSTATE_TERMINAL_ID = 2;
export const VAN_G_FOWLER_TERMINAL_ID = 43;
export const SAVAGE_TERMINAL_ID = 47;
export const MHX_TERMINAL_ID = 31;
export const USDG_SAN_BERNARDINO_ID = 56;

export const ingestedTerminalIds = [
	INTERSTATE_TERMINAL_ID,
	VAN_G_FOWLER_TERMINAL_ID,
	SAVAGE_TERMINAL_ID,
	MHX_TERMINAL_ID,
	USDG_SAN_BERNARDINO_ID,
];
